import { documentStackIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Docs = createIcon({
  displayName: 'Docs',
  paths: [
    'M213.333 170.667v597.333c-47.104 0-85.333-38.229-85.333-85.333v-512c0-47.104 38.229-85.333 85.333-85.333h426.667c47.104 0 85.333 38.229 85.333 85.333h-512zM383.915 256h426.837c47.104 0 85.248 38.187 85.248 85.248v512.171c0 47.061-38.144 85.248-85.248 85.248h-426.837c-47.061 0-85.248-38.187-85.248-85.248v-512.171c0-47.061 38.187-85.248 85.248-85.248zM810.752 853.333l-0.085-512h-426.752l0.085 512.085 426.752-0.085zM501.333 725.333c-17.664 0-32-19.115-32-42.667s14.336-42.667 32-42.667h192c17.664 0 32 19.115 32 42.667s-14.336 42.667-32 42.667h-192zM469.333 512c0 23.552 14.336 42.667 32 42.667h192c17.664 0 32-19.115 32-42.667s-14.336-42.667-32-42.667h-192c-17.664 0-32 19.115-32 42.667z'
  ],
  canvasPaths: canvasIconPaths(documentStackIcon)
})
